// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BcqO","comment":"styles_comment__jE4dg"};